var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ContainerInstance } from './container-instance.class';
/**
 * The container registry is responsible for holding the default and every
 * created container instance for later access.
 *
 * _Note: This class is for internal use and it's API may break in minor or
 * patch releases without warning._
 */
var ContainerRegistry = /** @class */ (function () {
    function ContainerRegistry() {
    }
    /**
     * Registers the given container instance or throws an error.
     *
     * _Note: This function is auto-called when a Container instance is created,
     * it doesn't need to be called manually!_
     *
     * @param container the container to add to the registry
     */
    ContainerRegistry.registerContainer = function (container) {
        if (container instanceof ContainerInstance === false) {
            // TODO: Create custom error for this.
            throw new Error('Only ContainerInstance instances can be registered.');
        }
        /** If we already set the default container (in index) then no-one else can register a default. */
        if (!!ContainerRegistry.defaultContainer && container.id === 'default') {
            // TODO: Create custom error for this.
            throw new Error('You cannot register a container with the "default" ID.');
        }
        if (ContainerRegistry.containerMap.has(container.id)) {
            // TODO: Create custom error for this.
            throw new Error('Cannot register container with same ID.');
        }
        ContainerRegistry.containerMap.set(container.id, container);
    };
    /**
     * Returns true if a container exists with the given ID or false otherwise.
     *
     * @param container the ID of the container
     */
    ContainerRegistry.hasContainer = function (id) {
        return ContainerRegistry.containerMap.has(id);
    };
    /**
     * Returns the container for requested ID or throws an error if no container
     * is registered with the given ID.
     *
     * @param container the ID of the container
     */
    ContainerRegistry.getContainer = function (id) {
        var registeredContainer = this.containerMap.get(id);
        if (registeredContainer === undefined) {
            // TODO: Create custom error for this.
            throw new Error('No container is registered with the given ID.');
        }
        return registeredContainer;
    };
    /**
     * Removes the given container from the registry and disposes all services
     * registered only in this container.
     *
     * This function throws an error if no
     *   - container exists with the given ID
     *   - any of the registered services threw an error during it's disposal
     *
     * @param container the container to remove from the registry
     */
    ContainerRegistry.removeContainer = function (container) {
        return __awaiter(this, void 0, void 0, function () {
            var registeredContainer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        registeredContainer = ContainerRegistry.containerMap.get(container.id);
                        if (registeredContainer === undefined) {
                            // TODO: Create custom error for this.
                            throw new Error('No container is registered with the given ID.');
                        }
                        /** We remove the container first. */
                        ContainerRegistry.containerMap.delete(container.id);
                        /** We dispose all registered classes in the container. */
                        return [4 /*yield*/, registeredContainer.dispose()];
                    case 1:
                        /** We dispose all registered classes in the container. */
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * The list of all known container. Created containers are automatically added
     * to this list. Two container cannot be registered with the same ID.
     *
     * This map doesn't contains the default container.
     */
    ContainerRegistry.containerMap = new Map();
    /**
     * The default global container. By default services are registered into this
     * container when registered via `Container.set()` or `@Service` decorator.
     */
    ContainerRegistry.defaultContainer = new ContainerInstance('default');
    return ContainerRegistry;
}());
export { ContainerRegistry };
//# sourceMappingURL=container-registry.class.js.map